export default "__VITE_ASSET__CY7VoZKM__"